export default __webpack_public_path__ + "static/media/banner.4d9d29ac.svg";